import { Divider, Typography } from "antd";
import * as React from "react";
import { IReport7Presenter } from "../../../presenter/report/Report7Presenter";
import Report7ParamBox from "../../components/report/report7Components/Report7ParamBox";
import Report7PDFExportLink from "../../components/report/report7Components/Report7PDFExportLink";
import Report7Preview from "../../components/report/report7Components/Report7Preview";

export interface Props {}

export interface State extends IReport7Presenter {}

export default class Report7Page extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      reportingPeriods,
      onReportingPeriodChange,
      applicants,
      onApplicantSearch,
      onApplicantsChange,
      formTypes,
      isFormTypesSelectDisabled,
      onFormTypeChange,
      formStructure,
      onSubmitParams,
      report7,
      selectedReportingPeriod
    } = this.state;

    return (
      <div className={"report-container"}>
        <Report7ParamBox
          translate={translate}
          reportingPeriods={reportingPeriods}
          onReportingPeriodChange={onReportingPeriodChange}
          applicants={applicants}
          onApplicantsSearch={onApplicantSearch}
          onApplicantsChange={onApplicantsChange}
          formTypes={formTypes}
          isFormTypesSelectDisabled={isFormTypesSelectDisabled}
          onChangeFormType={onFormTypeChange}
          formStructure={formStructure}
          onSubmit={onSubmitParams}
        />
        <Divider type={"vertical"} style={{ height: "100%" }} />
        <div style={{ overflow: "hidden", width: "75%" }}>
          {report7.length > 0 && (
            <div style={{ paddingLeft: 10 }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between"
                }}
              >
                <Typography.Title style={{ fontSize: 14 }}>
                  {translate("reports.review_report")}
                </Typography.Title>
                <div>
                  {!this.state.loaders.report7Loader && (
                    <Report7PDFExportLink
                      translate={translate}
                      report7Data={report7}
                      fileName={`${translate("report7.pdf_filename")}.pdf`}
                      selectedReportingPeriod={selectedReportingPeriod}
                    />
                  )}
                </div>
              </div>
              <Divider type={"horizontal"} />
              <Report7Preview
                translate={translate}
                report7Data={report7 || []}
                selectedReportingPeriod={selectedReportingPeriod}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
